import { Box } from '@modusign/design-system';
import { ReactNode } from 'react';

interface TabBoxProps {
  children: ReactNode;
}

const defaultProps = {
  children: null,
};

function TabBox({ children }: TabBoxProps) {
  return (
    <Box as="li" display="inline-block" p={[0, '0 12px']}>
      {children}
    </Box>
  );
}

TabBox.defaultProps = defaultProps;

export default TabBox;
